export default __webpack_public_path__ + "static/media/cli-patrus.03e0ca23.png";